<template>
  <b-badge
    v-if="status"
    :variant="tripColorGenerator(status)"
    class="trip-details-status-badge"
  >
    <span>{{ tripStatusFormatter(status) }}</span>
  </b-badge>
</template>

<script>
import { BBadge } from 'bootstrap-vue'
import { tripStatusFormatter, tripColorGenerator } from '../hooks/tripStatusUtils'

export default {
  components: {
    BBadge,
  },
  props: {
    status: {
      type: String,
      default: '',
    },
  },
  setup() {
    return {
      tripStatusFormatter,
      tripColorGenerator,
    }
  },
}
</script>

<style scoped>

.trip-details-status-badge {
    padding:8px;
    border-radius: 15px;
}
</style>
